import { render } from "./InstagramFeed.vue?vue&type=template&id=417bd374&scoped=true"
import script from "./InstagramFeed.vue?vue&type=script&lang=js"
export * from "./InstagramFeed.vue?vue&type=script&lang=js"

import "./InstagramFeed.vue?vue&type=style&index=0&id=417bd374&scoped=true&lang=css"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417bd374"],['__file',"src/js/Components/InstagramFeed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "417bd374"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('417bd374', __exports__)) {
    api.reload('417bd374', __exports__)
  }
  
  module.hot.accept("./InstagramFeed.vue?vue&type=template&id=417bd374&scoped=true", () => {
    api.rerender('417bd374', render)
  })

}


export default __exports__